export default __webpack_public_path__ + "static/media/Member_KuangYuWang.f52bf360.jpg";